import { reverse } from 'named-urls'

import type { PaymentApiClient } from '@fourthwall/services/dist/PaymentApiClient'
import { routing } from '@utils/routing'

import type { ChargeType } from '../Billing.types'

export type ChargesReasonData = Awaited<
  ReturnType<typeof PaymentApiClient.getShopCharges>
>['data']['charges'][number]['reason']

export const getChargeType = (data: ChargesReasonData): ChargeType => {
  if (data.type === 'ORDER_PLACED') {
    return {
      label: 'Order',
      url: reverse(routing.contributions.orders.order.self, { orderId: data.orderId }),
    }
  }

  if (data.type === 'ORDER_REFUNDED') {
    return {
      label: 'Order refund',
    }
  }

  if (data.type === 'ORDER_CANCELED') {
    return {
      label: 'Order cancel',
    }
  }

  if (data.type === 'INVENTORY_STORAGE_FEE') {
    return {
      label: 'Storage',
      url: reverse(routing.settings.shipping.inventoryStocks.self, {
        snapshotId: data.inventoryStocksSnapshotId,
      }),
    }
  }

  if (data.type === 'SAAS_PAYMENT') {
    return {
      label: 'Fourthwall Pro',
    }
  }

  return {
    label: '-',
  }
}
